import axios from 'axios';
import {BehaviorSubject, Subject} from 'rxjs';
import Sessione from '../../../services/sessione';
import i18next from 'i18next';
import {nellaLingua} from '../../../services/erroriConto';

const checkIsLoggedIn = () => {
    const token = window.localStorage.getItem('access_token');
    if (!token || token === 'null' || token === 'undefined') {
        return false;
    }

    // Il token basta: porta identità, scadenza e firma. Richiedere anche
    // CLIENT_SESSION significava restare fuori ogni volta che il server non
    // restituiva un sessionId — bastava ricaricare la pagina per uscire.
    try {
        const payload = JSON.parse(
            atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));

        // un token scaduto non vale, e continuare a usarlo produrrebbe solo
        // rifiuti a ogni chiamata
        if (payload.exp && payload.exp * 1000 < Date.now()) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
};

const loggedIn = new BehaviorSubject(checkIsLoggedIn());
const registredIn = new BehaviorSubject(false);
const errorMessage = new BehaviorSubject('');
const errorRegisterMessage = new BehaviorSubject('');
const showTicket = new BehaviorSubject(false);

/* QUANTE SELEZIONI CI SONO NELLA SCHEDINA, e CHI CHIEDE DI ENTRARE.
   Due avvisi che servono alla barra in basso, che sta nel guscio e non puo'
   vedere dentro la pagina delle quote ne' dentro la striscia in alto. Passano
   di qui come tutto il resto: un canale solo, quello che il sito gia' usa. */
const numeroSelezioni = new BehaviorSubject(contaSelezioniInMemoria());
const accesso = new Subject();
/* Qualcuno chiede di REGISTRARSI: la finestra di registrazione, come quella di
   accesso, vive nella striscia in alto (o nel guscio della skin). Porta con se'
   la ricerca dell'indirizzo (?code=… del ritorno da Telegram, ?invito=…). */
const registrazione = new Subject();

function contaSelezioniInMemoria() {
    try {
        const salvate = window.sessionStorage.getItem('allBets');
        const elenco = salvate ? JSON.parse(salvate) : [];
        return Array.isArray(elenco) ? elenco.length : 0;
    } catch (e) {
        return 0;
    }
}
const activateAccountWithTokenHasFailed = new Subject();
const usernameSubject = new BehaviorSubject(null);
const resendEmailStatus = new BehaviorSubject({success: false, message: ''});

/* TUTTO QUELLO CHE L'ACCESSO SCRIVE IN LOCALSTORAGE, tolto in un posto solo.
   Lo usano l'uscita volontaria e la fine della sessione decisa dal custode
   (scaduta, revocata, durata massima): due elenchi diventerebbero diversi
   alla prima chiave aggiunta. La schedina (sessionStorage) NON e' qui: si
   conserva, e si ritrova rientrando. */
const CHIAVI_PROFILO = [
    'CLIENT_SESSION', 'access_token', 'refresh_token', 'refresh_token_expiration',
    'USERNAME', 'USER_ROLE', 'USER_ID', 'BET_BLOCKED',
    'SALDO_UTENTE', 'SALDO_CONTABILE', 'SALDO_BONUS', 'FIDO_RETE', 'FIDO_DISP', 'DISPONIBILITA',
];

function svuotaProfilo() {
    CHIAVI_PROFILO.forEach((k) => window.localStorage.removeItem(k));
}

/* Quando il custode dice che la sessione e' finita (per tempo, per revoca,
   per durata massima) il profilo si svuota e il sito torna «fuori». Il
   motivo lo tiene il custode, e la finestra di accesso lo scrive. */
Sessione.collega({
    allaFine: () => {
        svuotaProfilo();
        usernameSubject.next(null);
        walletSubject.next(null);
        loggedIn.next(false);
    },
});

const allBets = window.sessionStorage.getItem('allBets');

const toggleTicket = (e) => {
    showTicket.next(e);
};

/** La pagina delle quote dice quante selezioni ci sono adesso. */
const impostaSelezioni = (n) => {
    numeroSelezioni.next(Number(n) || 0);
};

const selezioni = () => numeroSelezioni.asObservable();

/** Qualcuno chiede di entrare: la finestra di accesso la apre la striscia in
    alto, che e' l'unica che ce l'ha. */
const richiediAccesso = () => {
    accesso.next(true);
};

const accessoRichiesto = () => accesso.asObservable();

/**
 * Qualcuno chiede di registrarsi: `ricerca` e' la query dell'indirizzo da cui si
 * viene (puo' essere vuota). `telegram` ({idToken, nonce, user}), quando c'e', e'
 * l'account Telegram appena confermato che NON ha un conto: il modulo si apre
 * gia' compilato; con `avviso` lo dice («non hai ancora un conto: prosegui»).
 */
const richiediRegistrazione = (ricerca, telegram, avviso) => {
    registrazione.next({ricerca: ricerca || '', telegram: telegram || null, avviso: !!avviso});
};

const registrazioneRichiesta = () => registrazione.asObservable();

const initAuth = (onAuthenticatedCallback) => {
    Sessione.montaIntercettori();
    const avvia = () => {
        const dentro = checkIsLoggedIn();
        if (dentro) {
            initProfileIfLoggedIn();
            Sessione.avviaCustode();
        } else if (window.localStorage.getItem('access_token')) {
            // avanzi di una sessione finita da un pezzo: via, senza dire niente
            svuotaProfilo();
        }
        loggedIn.next(dentro);
        if (onAuthenticatedCallback) {
            onAuthenticatedCallback(dentro);
        }
    };
    // Il gettone d'accesso dura poco; la sessione di piu'. Se la pagina
    // viene ricaricata quando il gettone e' scaduto ma la sessione e'
    // ancora viva, si rinnova e si entra senza chiedere niente: prima
    // bastava un F5 dopo qualche minuto per trovarsi fuori.
    if (!checkIsLoggedIn() && Sessione.sessioneRiprendibile()) {
        Sessione.rinnova().then(avvia, avvia);
    } else {
        avvia();
    }
};

/**
 * Cio' che succede quando il servizio ha accettato un accesso: i gettoni e i
 * tempi della sessione, il nome, il profilo, il saldo. Era dentro doLogin:
 * ora lo usa anche l'accesso con Telegram, cosi' i due modi finiscono nello
 * stesso identico punto e il sito non sa come la persona e' stata riconosciuta.
 */
const accessoRiuscito = (data, nomePredefinito) => {
    // PRIMA SI SVUOTA quello che era rimasto di chi era entrato prima in questo
    // browser (nome, ruolo, id, saldi): con Telegram non si scrive nessun nome,
    // e la testata mostrava «utente» o i dati del conto precedente (17/10/2026).
    svuotaProfilo();

    // I gettoni e i TEMPI della sessione (quando scade il gettone,
    // quando scade la sessione, quanti secondi prima avvisare) li
    // manda il server, dalla regola della skin: li tiene il custode.
    Sessione.salvaGettoni(data);
    Sessione.consumaFine();

    // Chi e' entrato lo dice il server (username, userId); con la password
    // vale anche il nome scritto; in ultima istanza l'id sta nel gettone.
    const loginUsername = data.username || nomePredefinito || '';
    if (loginUsername) {
        window.localStorage.setItem('USERNAME', loginUsername);
        usernameSubject.next(loginUsername);
    }
    const userId = data.userId || userIdFromToken(data.access_token);
    if (userId) window.localStorage.setItem('USER_ID', String(userId));

    loggedIn.next(true);
    Sessione.avviaCustode();
    getProfile();

    // Il saldo va chiesto qui: senza, la barra resta a zero fino alla
    // prima ricarica della pagina.
    loadWalletData();
};

/**
 * ACCEDI CON TELEGRAM. La conferma di Telegram si manda al servizio, che la
 * verifica e fa entrare dallo stesso percorso della password: quello che
 * torna e' il gettone della piattaforma, identico agli altri. Telegram non
 * entra mai nei servizi.
 */
/* L'ESITO torna a chi chiama: {esito: 'dentro'} (il gettone e' arrivato),
   {esito: 'senzaConto'} (TELEGRAM_NON_COLLEGATO: nessun messaggio d'errore, il
   sito apre la registrazione gia' compilata con i dati di Telegram) oppure
   {esito: 'errore', messaggio} (il messaggio e' gia' stato scritto per la finestra). */
const doLoginTelegram = (idToken, nonce) => {
    const env = window.env || {};
    const gatewayUrl = env.REACT_APP_API_URL;
    if (!gatewayUrl) {
        errorMessage.next(i18next.t('Configurazione non disponibile'));
        loggedIn.next(false);
        return Promise.resolve({esito: 'errore', messaggio: i18next.t('Configurazione non disponibile')});
    }
    const config = {
        headers: {
            TENANT_ID: env.REACT_APP_API_TENANT || 1,
            'Content-Type': 'application/json',
            'X-Client-Surface': 'FRONTEND',
        },
    };
    const url = `${gatewayUrl}/${env.REACT_APP_API_VERSION || 'v1'}/users-management-service/api/login/telegram`;
    return axios.post(url, {idToken, nonce, dominio: window.location.hostname}, config)
        .then((res) => {
            if (!res.data || !res.data.access_token) {
                const messaggio = nellaLingua(res.data && res.data.message) || i18next.t('Accesso con Telegram non riuscito');
                errorMessage.next(messaggio);
                loggedIn.next(false);
                return {esito: 'errore', messaggio};
            }
            accessoRiuscito(res.data, '');
            return {esito: 'dentro'};
        })
        .catch((error) => {
            const d = error.response && error.response.data;
            // NESSUN CONTO con questo Telegram: non e' un errore da scrivere, e' la
            // registrazione che deve aprirsi (lo fa chi chiama, con i dati di Telegram).
            if (d && d.code === 'TELEGRAM_NON_COLLEGATO') {
                return {esito: 'senzaConto', messaggio: d.message};
            }
            // il servizio spiega sempre il perche': «in attesa», «sospeso»...
            let msg = i18next.t('Accesso con Telegram non riuscito. Riprova fra poco');
            if (d && d.message) {
                msg = d.message;
            } else if (error.request && !error.response) {
                msg = i18next.t('Impossibile connettersi al server. Verifica la connessione');
            }
            errorMessage.next(msg);
            loggedIn.next(false);
            return {esito: 'errore', messaggio: msg};
        });
};

const doLogin = (username, password) => {
    const env = window.env || {};
    const backofficeUrl = env.REACT_APP_BACKOFFICE_API_URL;
    const gatewayUrl = env.REACT_APP_API_URL;
    if (!backofficeUrl && !gatewayUrl) {
        console.error('window.env non configurato correttamente!');
        errorMessage.next(i18next.t('Configurazione non disponibile'));
        loggedIn.next(false);
        return;
    }
    const config = {
        headers: {
            TENANT_ID: env.REACT_APP_API_TENANT || 1,
            'Content-Type': 'application/json',
            // Da dove si sta entrando. Ogni altra chiamata del sito lo diceva
            // gia'; l'accesso no, ed era proprio quello il momento in cui
            // serviva: un'utenza di backoffice otteneva una sessione valida e
            // poi si trovava ogni richiesta respinta una per una, con
            // l'aspetto di un guasto invece che di un divieto.
            'X-Client-Surface': 'FRONTEND',
        },
    };
    // Il dominio dice la skin: chi appartiene a un'altra skin non entra da
    // qui. TENANT_ID vale 1 per tutte le skin e non distingue nessuno.
    const loginBody = { username, password, grant_type: 'PASSWORD', dominio: window.location.hostname };
    const loginUrl = backofficeUrl
        ? `${backofficeUrl}/api/auth/login`
        : `${gatewayUrl}/${env.REACT_APP_API_VERSION || 'v1'}/users-management-service/api/login/oauth`;
    // Restituito, non solo lanciato: chi cambia la password deve poter
    // aspettare che il rientro sia finito prima di decidere dove mandare la
    // persona. Chi non se ne cura continua a ignorarlo come ha sempre fatto.
    return axios.post(loginUrl, loginBody, config)
        .then((res) => {
            // Il server risponde 200 anche quando rifiuta: l'esito vero sta nel
            // corpo. Senza questo controllo axios considerava riuscita ogni
            // risposta, salvava un token nullo e faceva entrare chiunque.
            if (!res.data || !res.data.access_token) {
                errorMessage.next(nellaLingua(res.data && res.data.message)
                    || i18next.t('Username o password non corretti'));
                loggedIn.next(false);
                return;
            }

            accessoRiuscito(res.data, username);
        })
        .catch((error) => {
            let errorMsg = i18next.t('Credenziali non valide');
            if (error.response) {
                const status = error.response.status;
                const detto = nellaLingua(error.response.data && error.response.data.message);

                // 403: il server sa chi e' e ha deciso di non farlo entrare,
                // e sa anche perche'. Quello che dice vale piu' di qualunque
                // frase scritta qui - prima questo ramo rispondeva "controlla
                // le tue credenziali" a chi le aveva giuste e stava solo
                // bussando alla porta sbagliata.
                if (status === 403 && detto) {
                    errorMsg = detto;
                } else if (status === 401) {
                    // Volutamente vago: non si dice quale meta' e' sbagliata.
                    errorMsg = i18next.t('Username o password non corretti');
                } else if (status === 403) {
                    errorMsg = i18next.t('Accesso negato. Controlla le tue credenziali');
                } else if (status === 404) {
                    errorMsg = i18next.t('Servizio non disponibile. Riprova più tardi');
                } else if (status >= 500) {
                    errorMsg = i18next.t('Errore del server. Riprova più tardi');
                } else if (nellaLingua(error.response.data && error.response.data.message)) {
                    errorMsg = nellaLingua(error.response.data.message);
                }
            } else if (error.request) {
                errorMsg = i18next.t('Impossibile connettersi al server. Verifica la connessione');
            }
            
            errorMessage.next(errorMsg);
            loggedIn.next(false);
        });
};

/**
 * Il saldo, come canale che chiunque può ascoltare.
 *
 * Prima i valori finivano in localStorage senza avvisare nessuno: chi li
 * mostrava non aveva modo di sapere che erano cambiati, e serviva ricaricare la
 * pagina. Ora chi compie un'operazione chiama refreshWallet() e ogni schermata
 * che mostra il saldo si aggiorna da sé.
 */
const walletSubject = new BehaviorSubject(null);

const loadWalletData = () => {
    const env = window.env || {};
    const token = getToken();
    if (!token) return;

    const userId = userIdFromToken(token)
        || window.localStorage.getItem('USER_ID');
    if (!userId) return;

    const gatewayUrl = env.REACT_APP_API_URL || '';

    axios.get(`${gatewayUrl}/private/credit/${userId}/figures`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'X-Client-Surface': 'FRONTEND',
            TENANT_ID: env.REACT_APP_API_TENANT || 1,
        }
    })
    .then((res) => {
        const f = res.data || {};

        walletSubject.next({
            saldoUtente: f.userBalance || 0,
            disponibilita: f.available || 0,
            fidoDisp: f.creditAvailable || 0,
            saldoTotRete: f.networkBalance || 0,
            fidoRete: f.networkCredit || 0,
            saldoBonus: 0,
        });
    })
    .catch((error) => {
        console.warn('Errore caricamento saldo:', error.message);
    });
};

/** Da chiamare dopo ogni operazione che tocca il denaro. */
const refreshWallet = () => loadWalletData();

// Ogni operazione sul denaro annuncia di aver cambiato qualcosa: qui si
// ascolta, così il saldo si rinfresca da solo senza che nessuno lo chieda.
if (typeof window !== 'undefined') {
    window.addEventListener('wallet:changed', () => loadWalletData());
}

/** L'identificativo sta nel token, senza dipendere da altre chiamate. */
function userIdFromToken(token) {
    if (!token) return null;
    try {
        const payload = JSON.parse(
            atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload.userId || payload.sub || null;
    } catch (e) {
        return null;
    }
}

const getToken = () => {
    return window.localStorage.getItem('access_token');
};

const getProfile = () => {
    const env = window.env || {};
    const rawToken = window.localStorage.getItem('access_token');
    const token = (rawToken && rawToken !== 'null' && rawToken !== 'undefined') ? rawToken : null;
    if (!token) {
        console.warn('getProfile: token non valido, skip chiamata API');
        return;
    }
    if (!env.REACT_APP_API_URL && !env.REACT_APP_BACKOFFICE_API_URL) {
        console.error('window.env non configurato per getProfile!');
        return;
    }
    const config = {
        headers: {
            TENANT_ID: 1,
            access_token: token,
            Authorization: `Bearer ${token}`,
        },
    };
    const profileUrl = env.REACT_APP_BACKOFFICE_API_URL
        ? `${env.REACT_APP_BACKOFFICE_API_URL}/api/auth/profile`
        : `${env.REACT_APP_API_URL || env.REACT_APP_BACKOFFICE_API_URL}/profile`;
    axios.get(profileUrl, config)
        .then((res) => {
           const profile = res.data || {};
           const username = profile.username || profile.preferred_username || profile.email || '';
           if (username) {
               usernameSubject.next(username);
               window.localStorage.setItem('USERNAME', username);
           }
           let role = profile.role || profile.type || '';
           if (!role && profile.realm_access && Array.isArray(profile.realm_access.roles)) {
               const roles = profile.realm_access.roles.filter((r) => r && !r.startsWith('default'));
               role = roles.length ? roles[0] : '';
           }
           if (role) {
               window.localStorage.setItem('USER_ROLE', String(role).toUpperCase().replace(/-/g, '_'));
           }
           const userId = profile.id || profile.userId || profile.sub || '';
           if (userId) {
               window.localStorage.setItem('USER_ID', String(userId));
           }

           try {
               const betBlocked = !!(profile.preferences && profile.preferences.betBlocked);
               window.localStorage.setItem('BET_BLOCKED', JSON.stringify(betBlocked));
           } catch (e) {
               console.warn('Impossibile salvare BET_BLOCKED nel profilo', e);
           }

           try {
               const saldoUtente = Number(profile.saldoUtente) || 0;
               const saldoContabile = Number(profile.saldoContabile) || 0;
               const saldoBonus = Number(profile.saldoBonus) || 0;
               const fidoRete = Number(profile.fidoRete) || 0;
               const fidoDisp = Number(profile.fidoDisp) || Number(profile.fidoDisponibile) || fidoRete;
               const disponibilita = Number(profile.disponibilita) || (saldoUtente + fidoDisp);
               
               window.localStorage.setItem('SALDO_UTENTE', String(saldoUtente));
               window.localStorage.setItem('SALDO_CONTABILE', String(saldoContabile));
               window.localStorage.setItem('SALDO_BONUS', String(saldoBonus));
               window.localStorage.setItem('FIDO_RETE', String(fidoRete));
               window.localStorage.setItem('FIDO_DISP', String(fidoDisp));
               window.localStorage.setItem('DISPONIBILITA', String(disponibilita));
           } catch (e) {
               console.warn('Impossibile salvare dati saldo nel profilo', e);
           }
        })
        .catch((error) => {
            console.error('Errore nel recupero del profilo:', error);
        });
};

const refreshToken = () => {
    // Il rinnovo lo fa il custode: un rinnovo alla volta, all'indirizzo
    // giusto, e se il server dice di no (sessione scaduta, revocata, durata
    // massima) e' lui a chiudere e a scrivere il motivo.
    return Sessione.rinnova();
};

const doLogout = () => {
    const token = window.localStorage.getItem('access_token');
    const env = window.env || {};

    // Prima si chiude dal server: con il gettone ancora in mano. Il server
    // revoca la sessione (il gettone non vale piu', da nessuna parte) e la
    // toglie dal conteggio della skin. Se non risponde si esce lo stesso: un
    // server spento non deve tenere dentro nessuno.
    if (token && token !== 'null' && token !== 'undefined' && env.REACT_APP_API_URL) {
        axios.post(Sessione.urlUscita(), {}, {
            headers: {
                TENANT_ID: env.REACT_APP_API_TENANT || 1,
                'Content-Type': 'application/json',
                'X-Client-Surface': 'FRONTEND',
                Authorization: `Bearer ${token}`,
            },
        }).catch(() => {});
    }

    Sessione.fermaCustode();
    Sessione.dimenticaTempi();
    Sessione.consumaFine();
    svuotaProfilo();
    usernameSubject.next(null);
    walletSubject.next(null);
    loggedIn.next(false);
};

const doRegister = (data) => {
    if (!window.env || !window.env.REACT_APP_API_URL) {
        console.error('window.env non configurato per doRegister!');
        registredIn.next(false);
        return;
    }
    
    const accessToken = window.localStorage.getItem('access_token');
    const headers = {
        'Content-Type': 'application/json',
        TENANT_ID: window.env.REACT_APP_API_TENANT || 1
    };
    
    if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
    } else {
        headers.Authorization = 'Bearer public';
    }
    
    const config = { headers: headers };
    
    axios.post(`${window.env.REACT_APP_API_URL}/${window.env.REACT_APP_API_VERSION || 'v1'}/users-management-service/register`, data, config)
        .then((res) => {
            if (res.status === 200 || res.status === 201) {
                if (data.email) {
                    window.sessionStorage.setItem('PENDING_ACTIVATION_EMAIL', data.email);
                }
                registredIn.next(true);
            }
        })
        .catch((error) => {
            registredIn.next(false);
            if (error?.response?.data) {
                const errorData = error.response.data;
                if (typeof errorData === 'string' && errorData.includes('Authorization')) {
                    errorRegisterMessage.next([{ 
                        message: i18next.t('Errore di autenticazione. Se il problema persiste, contatta il supporto.'),
                        field: 'authorization'
                    }]);
                    return;
                }
                
                if (errorData.errorMessageList && Array.isArray(errorData.errorMessageList)) {
                    const sanitizedErrors = errorData.errorMessageList.map(err => {
                        if (typeof err === 'string') {
                            return { message: err };
                        }
                        return err || { message: i18next.t('Errore sconosciuto') };
                    });
                    errorRegisterMessage.next(sanitizedErrors);
                } else if (errorData.message) {
                    errorRegisterMessage.next([{ message: errorData.message }]);
                } else if (errorData.error) {
                    errorRegisterMessage.next([{ message: errorData.error }]);
                } else if (typeof errorData === 'string') {
                    errorRegisterMessage.next([{ message: errorData }]);
                } else {
                    const status = error.response.status;
                    let errorMsg = i18next.t('Errore durante la registrazione');
                    if (status === 400) {
                        errorMsg = i18next.t('Dati non validi. Controlla i campi inseriti');
                    } else if (status === 409) {
                        errorMsg = i18next.t('Username o email già esistente');
                    } else if (status >= 500) {
                        errorMsg = i18next.t('Errore del server. Riprova più tardi');
                    }
                    errorRegisterMessage.next([{ message: errorMsg }]);
                }
            } else if (error.request) {
                errorRegisterMessage.next([{ message: i18next.t('Impossibile connettersi al server. Verifica la connessione') }]);
            } else {
                errorRegisterMessage.next([{ message: i18next.t('Errore durante la registrazione. Riprova') }]);
            }
        });
};

const doValidateToken = (token) => {
    if (!window.env || !window.env.REACT_APP_API_URL) {
        console.error('window.env non configurato per doValidateToken!');
        activateAccountWithTokenHasFailed.next(true);
        return;
    }
    
    const config = {
        headers: {
            TENANT_ID: 1
        },
    };
    axios.post(`${window.env.REACT_APP_API_URL}/users/register/complete`, {token: token}, config)
        .then((res) => {
            if (res.status && res.data.status === 200) {
                activateAccountWithTokenHasFailed.next(false)
            }
            if(res.data.status === 500) {
                activateAccountWithTokenHasFailed.next(true)
            }
        })
        .catch((error) => {
            activateAccountWithTokenHasFailed.next(true)
            if (error?.response?.data) {
                errorRegisterMessage.next(error?.response?.data?.errorMessageList);
            }
        });
};

const doResendActivationEmail = (email) => {
    if (!window.env || !window.env.REACT_APP_API_URL) {
        console.error('window.env non configurato per doResendActivationEmail!');
        resendEmailStatus.next({success: false, message: i18next.t('Configurazione non disponibile')});
        return;
    }
    
    const emailToUse = email || window.sessionStorage.getItem('PENDING_ACTIVATION_EMAIL');
    if (!emailToUse) {
        resendEmailStatus.next({success: false, message: i18next.t('Email non disponibile')});
        return;
    }
    
    const config = {
        headers: {
            TENANT_ID: window.env.REACT_APP_API_TENANT || 1
        },
    };
    
    const endpoints = [
        `${window.env.REACT_APP_API_URL}/${window.env.REACT_APP_API_VERSION || 'v1'}/users-management-service/register/resend-email`,
        `${window.env.REACT_APP_API_URL}/${window.env.REACT_APP_API_VERSION || 'v1'}/users-management-service/resend-activation-email`,
        `${window.env.REACT_APP_API_URL}/registration-service/resend-activation-email`,
        `${window.env.REACT_APP_API_URL}/users/resend-activation-email`
    ];
    
    axios.post(endpoints[0], {email: emailToUse}, config)
        .then((res) => {
            if (res.status === 200 || res.status === 204) {
                resendEmailStatus.next({success: true, message: i18next.t('Email di attivazione inviata con successo!')});
            } else {
                resendEmailStatus.next({success: false, message: i18next.t('Errore nell\'invio dell\'email')});
            }
        })
        .catch((error) => {
            const tryNextEndpoint = (index) => {
                if (index >= endpoints.length) {
                    resendEmailStatus.next({
                        success: false, 
                        message: i18next.t('Servizio di invio email non disponibile. Contatta il supporto.')
                    });
                    return;
                }
                
                axios.post(endpoints[index], {email: emailToUse}, config)
                    .then((res) => {
                        if (res.status === 200 || res.status === 204) {
                            resendEmailStatus.next({success: true, message: i18next.t('Email di attivazione inviata con successo!')});
                        } else {
                            resendEmailStatus.next({success: false, message: i18next.t('Errore nell\'invio dell\'email')});
                        }
                    })
                    .catch(() => {
                        tryNextEndpoint(index + 1);
                    });
            };
            
            tryNextEndpoint(1);
        });
};

const getResendEmailStatus = () => {
    return resendEmailStatus.asObservable();
};

const doPasswordRecover = (email) => {
    if (!window.env || !window.env.REACT_APP_API_URL) {
        console.error('window.env non configurato per doPasswordRecover!');
        return;
    }
    
    const config = {
        headers: {
            SKIN_ID: 1,
        },
    };
    const data = {email: email};
    axios.post(`${window.env.REACT_APP_API_URL}/registration-service/password/forgot/email`, data, config)
        .then((res) => {
            console.log(res, 'res in doPasswordRecover');
        })
        .catch((res) => {
            console.log(res, 'res in catch DoPasswordRecover');
        });
};

const isLoggedIn = () => {
    return loggedIn.asObservable();
};

const isRegisteredIn = () => {
    return registredIn.asObservable();
};

const handleErrorMessage = () => {
    return errorMessage.asObservable();
};

const handleRegisterErrorMessage = () => {
    return errorRegisterMessage.asObservable();
};

const clearErrorMessage = () => {
    errorMessage.next('');
    errorRegisterMessage.next('');
};

const getRole = () => {
    return window.localStorage.getItem('USER_ROLE') || '';
};

const getUsername = () => {
    const storedUsername = window.localStorage.getItem('USERNAME');
    if (storedUsername) {
        return storedUsername;
    }
    const currentUsername = usernameSubject.getValue();
    if (currentUsername) {
        return currentUsername;
    }
    const session = window.localStorage.getItem('CLIENT_SESSION');
    if (session) {
        return 'Utente';
    }
    return null;
};

const showTicketToggle = () => {
    return showTicket.asObservable();
};

const initProfileIfLoggedIn = () => {
    const session = window.localStorage.getItem('CLIENT_SESSION');
    const token = window.localStorage.getItem('access_token');
    const validSession = session && session !== 'null' && session !== 'undefined';
    const validToken = token && token !== 'null' && token !== 'undefined';
    if (validSession && validToken) getProfile();
};

const UserService = {
    initAuth,
    doLogin,
    doLoginTelegram,
    doLogout,
    initProfileIfLoggedIn,
    doRegister,
    getRole,
    doPasswordRecover,
    doResendActivationEmail,
    getResendEmailStatus,
    isLoggedIn,
    isRegisteredIn,
    getUsername,
    getToken,
    handleErrorMessage,
    handleRegisterErrorMessage,
    clearErrorMessage,
    doValidateToken,
    activateAccountWithTokenHasFailed,
    allBets,
    refreshToken,
    toggleTicket,
    showTicketToggle,
    impostaSelezioni,
    selezioni,
    richiediAccesso,
    accessoRichiesto,
    richiediRegistrazione,
    registrazioneRichiesta,
    loadWalletData,
    walletSubject,
    refreshWallet,
    // la sessione: perche' e' finita, l'avviso che sta per finire, «resto collegato»
    fineSessione: Sessione.fineSessione,
    consumaFineSessione: Sessione.consumaFine,
    avvisoSessione: Sessione.avvisoSessione,
    restoCollegato: Sessione.restoCollegato,
};

export default UserService;
